module.exports = __webpack_public_path__ + "img/regiter-icon01-selected.5ec67120.png";